<script>
    export let size = 24
    export let color = '#C5281C'
    export let style = ''
    export let title = null
</script>

<svg
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.668 0H3.292C1.477 0 0 1.792 0 3.994V15.3496V21.279V29.6896C0 31.5636 1.477 33.0886 3.292 33.0886H10.844C11.12 33.0886 11.344 32.8656 11.344 32.5886C11.344 32.3126 11.12 32.0886 10.844 32.0886H3.292C2.028 32.0886 1 31.0126 1 29.6896V21.279V15.3496V3.994C1 2.343 2.028 1 3.292 1H44.668C45.932 1 46.959 2.343 46.959 3.994V15.3496V20.35V29.6896C46.959 31.0126 45.932 32.0886 44.668 32.0886H37.06C36.783 32.0886 36.56 32.3126 36.56 32.5886C36.56 32.8656 36.783 33.0886 37.06 33.0886H44.668C46.482 33.0886 47.959 31.5636 47.959 29.6896V20.35V15.3496V3.994C47.959 1.792 46.482 0 44.668 0ZM24.042 17.9218C24.0231 17.9218 24.0045 17.9228 23.9861 17.9249C23.8873 17.9358 23.791 17.9761 23.711 18.0468C23.6927 18.063 23.676 18.0803 23.6606 18.0984L13.478 29.3358C13.292 29.5408 13.308 29.8578 13.512 30.0418C13.715 30.2268 14.031 30.2108 14.218 30.0078L23.542 19.7179V47.4938C23.542 47.7708 23.766 47.9938 24.042 47.9938C24.318 47.9938 24.542 47.7708 24.542 47.4938V19.7428L33.414 29.7808C33.6 29.9898 33.916 30.0078 34.12 29.8248C34.327 29.6418 34.347 29.3258 34.164 29.1188L24.417 18.0908C24.3924 18.0632 24.3656 18.039 24.337 18.0181C24.2599 17.9617 24.1661 17.9268 24.0645 17.9223L24.0539 17.9219L24.042 17.9218Z"
        fill={color}
    ></path>
    <mask
        id="mask0_2522_158378"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M44.668 0H3.292C1.477 0 0 1.792 0 3.994V15.3496V21.279V29.6896C0 31.5636 1.477 33.0886 3.292 33.0886H10.844C11.12 33.0886 11.344 32.8656 11.344 32.5886C11.344 32.3126 11.12 32.0886 10.844 32.0886H3.292C2.028 32.0886 1 31.0126 1 29.6896V21.279V15.3496V3.994C1 2.343 2.028 1 3.292 1H44.668C45.932 1 46.959 2.343 46.959 3.994V15.3496V20.35V29.6896C46.959 31.0126 45.932 32.0886 44.668 32.0886H37.06C36.783 32.0886 36.56 32.3126 36.56 32.5886C36.56 32.8656 36.783 33.0886 37.06 33.0886H44.668C46.482 33.0886 47.959 31.5636 47.959 29.6896V20.35V15.3496V3.994C47.959 1.792 46.482 0 44.668 0ZM24.042 17.9218C24.0231 17.9218 24.0045 17.9228 23.9861 17.9249C23.8873 17.9358 23.791 17.9761 23.711 18.0468C23.6927 18.063 23.676 18.0803 23.6606 18.0984L13.478 29.3358C13.292 29.5408 13.308 29.8578 13.512 30.0418C13.715 30.2268 14.031 30.2108 14.218 30.0078L23.542 19.7179V47.4938C23.542 47.7708 23.766 47.9938 24.042 47.9938C24.318 47.9938 24.542 47.7708 24.542 47.4938V19.7428L33.414 29.7808C33.6 29.9898 33.916 30.0078 34.12 29.8248C34.327 29.6418 34.347 29.3258 34.164 29.1188L24.417 18.0908C24.3924 18.0632 24.3656 18.039 24.337 18.0181C24.2599 17.9617 24.1661 17.9268 24.0645 17.9223L24.0539 17.9219L24.042 17.9218Z"
            fill="white"
        ></path>
    </mask>
    <g mask="url(#mask0_2522_158378)">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0H48V48H0V0Z"
            fill={color}
        ></path>
    </g>
</svg>
